import { Box, Button } from '@factorialco/deprecated-design-system'

import Modal from 'modules/core/components/Modal'
import i18n from 'modules/core/lib/i18n'

interface Props {
  onPublish: () => void
  publishingForm: boolean
  publishingWorkflow: boolean
  onPublishLoading: boolean
  onClose: () => void
}
const PublishTypeModal = ({
  onPublish,
  onClose,
  onPublishLoading,
  publishingForm,
  publishingWorkflow,
}: Props) => {
  // Determine the correct description based on what's being published
  const getDescription = () => {
    if (publishingForm && publishingWorkflow) {
      return i18n.t('procurement.purchase_requests.settings.types.modals.publish.description_both')
    }
    if (publishingForm) {
      return i18n.t('procurement.purchase_requests.settings.types.modals.publish.description_form')
    }
    if (publishingWorkflow) {
      return i18n.t(
        'procurement.purchase_requests.settings.types.modals.publish.description_workflow'
      )
    }
    return i18n.t('procurement.purchase_requests.settings.types.modals.publish.description_both')
  }

  return (
    <Modal
      illustration="input-field"
      title={i18n.t('procurement.purchase_requests.settings.types.modals.publish.title')}
      description={getDescription()}
      footer={
        <>
          <Button type="secondary" onClick={onClose}>
            {i18n.t('common.cancel')}
          </Button>
          <Button onClick={onPublish} disabled={onPublishLoading}>
            {i18n.t('procurement.purchase_requests.settings.types.modals.publish.buttons.publish')}
          </Button>
        </>
      }
      onClose={onClose}
    >
      <Box gap="s16"></Box>
    </Modal>
  )
}

export default PublishTypeModal
